import React, { useEffect, useState } from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";
import { fetchApplicationInstalationRequest } from "../../store/Dashboard/dashboardAction";
import { useSelector, useDispatch } from "react-redux";

// Import Charts
import ReactApexChart from 'react-apexcharts';
import "./dashboard.scss";

const ApplicationDownloader = () => {
    const [series, setSeries] = useState([0]);
    const [series2, setSeries2] = useState([0]);
    const [selectedDays, setSelectedDays] = useState(3);

    const handleTimeRangeChange = (event) => {
        setSelectedDays(event.target.value);
    };

    const dispatch = useDispatch();
    const { data: applicationInstallation, loading, error } = useSelector(
        (state) => state.applicationInstallation || {}
    );

    useEffect(() => {
        dispatch(fetchApplicationInstalationRequest(selectedDays));
    }, [dispatch, selectedDays]);

    useEffect(() => {
        if (applicationInstallation.androiDownloader !== undefined && applicationInstallation.iOSDownloader !== undefined) {
            setSeries([applicationInstallation.androiDownloader]);
            setSeries2([applicationInstallation.iOSDownloader]);
        }
    }, [applicationInstallation]);

    const options = {
        chart: {
            sparkline: {
                enabled: true
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#5664d2'],
        stroke: {
            lineCap: 'round'
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 0,
                    size: '70%'
                },
                track: {
                    margin: 0,
                },
                dataLabels: {
                    show: false
                }
            }
        }
    };

    const options2 = {
        chart: {
            sparkline: {
                enabled: true
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#1cbb8c'],
        stroke: {
            lineCap: 'round'
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 0,
                    size: '70%'
                },
                track: {
                    margin: 0,
                },
                dataLabels: {
                    show: false
                }
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className="float-end">
                        <select
                            className="form-select form-select-sm"
                            value={selectedDays}  // Set the selected value
                            onChange={handleTimeRangeChange}  // Handle change event
                        >
                            <option value={3}>3 Days</option>
                            <option value={5}>5 Days</option>
                            <option value={7}>7 Days</option>
                        </select>
                    </div>
                    <h4 className="card-title mb-4 mt-2">App Installation Summary</h4>
                    <div className="text-center">
                        <Row>
                            <Col sm={6}>
                                <div>
                                    <div className="mb-3">
                                        <div id="radialchart-1" className="apex-charts">
                                            <ReactApexChart options={options} series={series} type="radialBar" height="60" />
                                        </div>
                                    </div>
                                    <p className="text-muted text-truncate mb-2">Android App</p>
                                    <h5 className='mb-0'>{series[0]}</h5>
                                </div>
                            </Col>

                            <Col sm={6}>
                                <div className="mt-5 mt-sm-0">
                                    <div className="mb-3">
                                        <div id="radialchart-2" className="apex-charts">
                                            <ReactApexChart options={options2} series={series2} type="radialBar" height="60" />
                                        </div>
                                    </div>
                                    <p className="text-muted text-truncate mb-2">iOS App</p>
                                    <h5 className='mb-0'>{series2[0]}</h5>
                                </div>
                            </Col>

                        </Row>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default ApplicationDownloader;
